import { useState, useEffect } from 'react';
import axios from 'axios';
import { BACKEND_ENDPOINT } from './config/authConfig';

export function useIsAuthenticated() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    axios.get(`${BACKEND_ENDPOINT}/auth/me`, { withCredentials: true })
      .then(res => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  return { user, checking };
}

export function logoutUser() {
  return axios.post(`${BACKEND_ENDPOINT}/auth/logout`, {}, { withCredentials: true });
}
